/* eslint-disable camelcase */
export default {
    en: {
        title: 'Job preferences',
        updateTitle: 'Update job preferences',
        emptyPreferencesDescription: 'No preferences set. Tell us about shifts, locations, skills and schedule you prefer.',
        description: 'Describe your perfect job and we use it as insights to find you the best opportunities',
        inputPlaceholder: 'E.g., "Morning shifts, 80-100%, within 30 minutes from home"',
        send: 'Send',
        successToastText: 'Sent successfully',
        lastUpdated: 'Last updated {{date}}'
    },
    no: {
        title: 'Jobbpreferanser',
        updateTitle: 'Oppdater jobbpreferanser',
        emptyPreferencesDescription: 'Ingen preferanser satt. Fortell oss om skift, lokasjoner, ferdigheter og timeplan du foretrekker.',
        description: 'Beskriv din perfekte jobb, og vi bruker den som innsikt for å finne de beste mulighetene for deg',
        inputPlaceholder: 'Eks., "Morgenvakter, 80-100%, maks 30 minutter hjemmefra"',
        send: 'Send',
        successToastText: 'Sendt vellykket',
        lastUpdated: 'Sist oppdatert {{date}}'
    },
    sv: {
        title: 'Jobbpreferenser',
        updateTitle: 'Uppdatera jobbpreferenser',
        emptyPreferencesDescription: 'Inga preferenser är inställda. Berätta för oss om skift, platser, färdigheter och schema du föredrar.',
        description: 'Beskriv ditt perfekta jobb och vi använder det som insikter för att hitta de bästa möjligheterna för dig',
        inputPlaceholder: 'Ex., "Morgonpass, 80-100%, max 30 minuter från hemmet"',
        send: 'Skicka',
        successToastText: 'Skickat framgångsrikt',
        lastUpdated: 'Senast uppdaterad {{date}}'
    }
} as const;
